/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_CutInputs */

const en_shortcut_keys_name_cut = /** @type {(inputs: Shortcut_Keys_Name_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cut`)
};

const fr_shortcut_keys_name_cut = /** @type {(inputs: Shortcut_Keys_Name_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couper`)
};

const de_shortcut_keys_name_cut = /** @type {(inputs: Shortcut_Keys_Name_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schneiden`)
};

const it_shortcut_keys_name_cut = /** @type {(inputs: Shortcut_Keys_Name_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taglio`)
};

const ru_shortcut_keys_name_cut = /** @type {(inputs: Shortcut_Keys_Name_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Резать`)
};

const es_shortcut_keys_name_cut = /** @type {(inputs: Shortcut_Keys_Name_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cortar`)
};

const zh_cn2_shortcut_keys_name_cut = /** @type {(inputs: Shortcut_Keys_Name_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切`)
};

const ja_shortcut_keys_name_cut = /** @type {(inputs: Shortcut_Keys_Name_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カット`)
};

const hi_shortcut_keys_name_cut = /** @type {(inputs: Shortcut_Keys_Name_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`काटना`)
};

const pt_pt2_shortcut_keys_name_cut = /** @type {(inputs: Shortcut_Keys_Name_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corte`)
};

/**
* | output |
* | --- |
* | "Cut" |
*
* @param {Shortcut_Keys_Name_CutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cut = /** @type {((inputs?: Shortcut_Keys_Name_CutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_CutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_cut(inputs)
	if (locale === "de") return de_shortcut_keys_name_cut(inputs)
	if (locale === "it") return it_shortcut_keys_name_cut(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_cut(inputs)
	if (locale === "es") return es_shortcut_keys_name_cut(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_cut(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_cut(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_cut(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_cut(inputs)
	return en_shortcut_keys_name_cut(inputs)
});